module.exports = __webpack_public_path__ + "media/images/proof_links/mixcloud-0407bdc656e44e85be1e820820674791.svg";